import CommonTextField from "components/common/CommonTextField";
import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { IoCloseOutline } from "react-icons/io5";

const EditPageTitles = ({ isOpen, onClose, item, onSubmit }) => {
  const [heading, setHeading] = useState("");

  useEffect(() => {
    if (item) {
      setHeading(item?.heading ?? "");
    }
  }, [item]);

  const updateItem = () => {
    const data = {
      itemId: item?._id,
      heading: heading ?? item?.heading,
    };
    onSubmit(data);
  };

  return (
    <Modal show={isOpen} onHide={onClose} backdrop="static" keyboard={false}>
      <Modal.Header>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <Modal.Title style={{ fontWeight: "600", fontSize: 20 }}>
            Edit In-App Page Title
          </Modal.Title>
          <p
            style={{
              marginBottom: 0,
              paddingBottom: 0,
              fontWeight: "400",
              fontSize: 15,
            }}
          >
            {item?.title ?? ""}
          </p>
        </div>

        <div onClick={onClose} style={{ cursor: "pointer" }}>
          <IoCloseOutline size={24} />
        </div>
      </Modal.Header>

      <Modal.Body>
        {/* Input Group */}
        <CommonTextField
          label={"Page Title"}
          value={heading}
          onChange={(e) => setHeading(e.target.value)}
          placeholder={"Page Title"}
        />

        <div style={{ display: "flex", flexDirection: "row" }}>
          <Button
            variant="secondary"
            style={{ width: "48%", fontSize: 14, borderRadius: 8 }}
            onClick={onClose}
          >
            Cancel
          </Button>

          <div style={{ flex: 1 }} />

          <Button
            variant="primary"
            onClick={updateItem}
            style={{ width: "48%", fontSize: 14, borderRadius: 8 }}
            type="submit"
          >
            Update Page Title
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default EditPageTitles;
